import MyAxios from "../utils/request"
import md5 from "md5-node"

const pub = {
    login: function (cellphone, password) {
        let data = { cellphone, password: md5(password) }
        return MyAxios.post('/pubServer/account/login', data)
    },
    sendValidCode: function (cellphone) {
        return MyAxios.get('/pubServer/message/sendForgetPasswordMessage/'+cellphone)
    },
    updatePassword: function (cellphone, password, code) {
        let data = { cellphone, password, code }
        return MyAxios.post('/pubServer/account/forgetPassword', data)
    }
}

const competition = {
    getPendant: function(account){
        let data = [account]
        return MyAxios.post('/elearning-competition/head/getAccountHead', data)
    }
}

const live = {
    getConfigs: function () {
        return MyAxios.get('/elearning-live/configs/getConfigs')
    },
    getLatestLive: function () {
        return MyAxios.get('/elearning-live/lives/getLatestLive')
    },
    checkAuthorization: function (liveId) {
        return MyAxios.post('/elearning-live/app/v2/checkAuthorization',{liveId})
    },
    getLiveList: function (current) {
        let data = { current, size: 10 }
        return MyAxios.get('/elearning-live/app/getLiveList', { params: data })
    },
    getHistoryLiveList: function (current) {
        let data = { type: 2, current, size: 12 }
        return MyAxios.get('/elearning-live/app/getLiveList', { params: data })
    },
    getLiveDetail: function (liveId) {
        let data = { liveId }
        return MyAxios.get('/elearning-live/app/getLiveDetail', { params: data })
    },
    getLiveStatus: function (liveId){
        return MyAxios.get('/elearning-live/stream/getLiveStatus?id='+liveId)
    },
    getLiveComment: function (liveId) {
        let data = { current: 1, size: 10, liveId }
        return MyAxios.get('/elearning-live/app/getLatestComments', { params: data })
    },
    createComment: function (liveId, content) {
        let form = new FormData();
        form.append('liveId', liveId)
        form.append('content', content)
        form.append('replyTo', 0)
        return MyAxios.post('/elearning-live/app/createComment', form)
    },
    sendGift: function (liveId, giftId, giftNum) {
        // let data = { liveId, giftId, giftNum }
        let formData = new FormData()
        formData.append("liveId",liveId)
        formData.append("giftId",giftId)
        formData.append("giftNum",giftNum)
        return MyAxios.post('/elearning-live/gifts/send', formData)
    },
    // getAwardRecord: function (questionPushId) {
    //     return MyAxios.get('/elearning-live/questionnaire/getAwardResult/'+questionPushId)
    // },
    getIntercationPush: function (liveId) {
        return MyAxios.get('/elearning-live/app/interactionLog/'+liveId)
    },
    submitIntercation: function (packetPushId,packetId, selects, useTime) {
        let data = { packetPushId, packetId, selects ,useTime}
        return MyAxios.post('/elearning-live/app/submitQuestion', data)
    },
    likeLive: function (liveId) {
        let data = new FormData();
        data.append("liveId",liveId)
        return MyAxios.post('/elearning-live/app/likeLives', data)
    },
    unLikeLive: function (liveId) {
        let data = new FormData();
        data.append("liveId",liveId)
        return MyAxios.post('/elearning-live/app/unLikeLives', data)
    }
}


export default {
    pub,
    competition,
    live
}



// WEBPACK FOOTER //
// ./src/actions/index.js